//# sourceMappingURL=common.mjs.map
/// <reference types="./common.d.mts" />
import * as $weaviate from "../../../data_types/data/weaviate.mjs";
import * as $dropdown from "../../../ds/ds/components/dropdown.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import { toList } from "../../gleam.mjs";

export function variant_choices() {
  return $list.map(
    $weaviate.all_variants,
    (v) => { return $dropdown.choice($weaviate.variant_to_string(v), v); },
  );
}

export function collection_kind_choices() {
  return toList([
    $dropdown.choice("Document", new $weaviate.Document()),
    $dropdown.choice("Chunk", new $weaviate.Chunk()),
  ]);
}
